import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import styles from './header.module.scss'

const Header = () => (
  <div className={styles.header}>
    <div className={styles.header_content}>
      <div className={styles.link}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          <p className={styles.main_title}>Chloe</p>
          <p className={styles.subtitle}>Web dev</p>
        </Link>
      </div>
    </div>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  subTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
  subTitle: ``,
}

export default Header
